import { useQuery } from '@tanstack/react-query';

import { http, queryKeys, type ApiError } from '@/shared/api';

import type { MyAccess } from '../types/access.types';

const accessApi = {
  getMyAccess: () => http.get<MyAccess>('/users/me/access'),
} as const;

/**
 * The session's authorization bootstrap.
 *
 * Fetched once per session and reused by every guard and `<Can>` check, so it
 * is cached aggressively. It must be invalidated whenever the user's standing
 * changes — creating a complex or building (which grants a role) or having a
 * membership request approved — otherwise the app keeps rendering the previous
 * role's navigation.
 */
export function useMyAccess({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<MyAccess, ApiError>({
    queryKey: queryKeys.session.access(),
    queryFn: accessApi.getMyAccess,
    enabled,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}

export { accessApi };
